import {
    requestCreate,
    requestDelete,
    requestUpdate,
    sendRequest
} from "../api"
import {
    ADD_TO_OPTION,
    REMOVE_FROM_OPTION,
    RESET_STATE,
    SET_OPTION,
    UPDATE_IN_OPTION
} from "../constant-types"
import { defaultAddToOptionMutation, defaultRemoveFromOptionMutation, defaultSetOptionMutation, defaultUpdateInOptionMutation } from "../default-method"

const getDefaultState = () => {
    return {
        options: []
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetOptionMutation,
        ...defaultAddToOptionMutation,
        ...defaultUpdateInOptionMutation,
        ...defaultRemoveFromOptionMutation
        

    },
    // can async
    actions: {
        loadOption({commit}) {
            return sendRequest('warehouse/option', {}, 'get', (list) => commit(SET_OPTION, list))
        },
        requestCreateWarehouse({commit, rootState}) {
            return requestCreate('warehouse', rootState.warehouseForm.rows[0], commit, ADD_TO_OPTION )
        },
        requestUpdateWarehouse({commit, rootState}) {
            return requestUpdate(`warehouse/${rootState.warehouseForm.rows[0].id}`, rootState.warehouseForm.rows[0], commit, UPDATE_IN_OPTION)
        },
        requestDeleteWarehouse({commit, rootState}, warehouse) {
            return requestDelete(`warehouse/${warehouse.id}`, {}, commit, warehouse.name, REMOVE_FROM_OPTION)
        }
    },
    // call variable with custom display
    getters: {
        
    },
})
